import { useAuth0 } from '@auth0/auth0-react'
import { UseQueryResult, useQuery, UseQueryOptions } from '@tanstack/react-query'
import { QueryKeys } from '../../types'
import { getWeekTimeSlots } from './timeSlots'
import type { FetchTimeSlotsParams, WeekTimeSlotsResponse } from './types'

export const useGetWeekTimeSlotsQuery = (
  params: FetchTimeSlotsParams,
  options?: Omit<UseQueryOptions<WeekTimeSlotsResponse, Error>, 'queryKey' | 'queryFn'>
): UseQueryResult<WeekTimeSlotsResponse, Error> => {
  const { getAccessTokenSilently } = useAuth0()

  return useQuery({
    queryKey: [QueryKeys.TimeSlots, 'private', 'week', params.fromDate, params.toDate],
    queryFn: async () => {
      const accessToken = await getAccessTokenSilently()
      return await getWeekTimeSlots({ accessToken, ...params })
    },
    retry: false,
    ...options,
  })
}
